// import 'admin/assets/css/react-datepicker.css'

import { FC } from "react"
import ReactDatePicker from "react-datepicker"

// import de from "date-fns/locale/de"
import "react-datepicker/dist/react-datepicker.css"
import "./datepicker.css"

// registerLocale("de", de)

export const DatePicker: FC<any> = (props) => {
  const {
    customInput,
    onChange,
    selected,
    value,
    maxDate,
    className,
    endDate,
    placeholderText,
    selectsRange,
    startDate,
    shouldCloseOnSelect,
    disabled,
    wrapperClassName,
    showTimeInput,
    ...rest
  } = props
  return (
    <ReactDatePicker
      className={className}
      customInput={customInput}
      // dateFormat="dd/MM/yyyy"
      disabled={disabled}
      endDate={endDate}
      fixedHeight
      // locale="de"
      maxDate={maxDate}
      onChange={onChange}
      placeholderText={placeholderText}
      selected={selected}
      selectsRange={selectsRange}
      shouldCloseOnSelect={shouldCloseOnSelect}
      showMonthDropdown
      showTimeInput={showTimeInput}
      showYearDropdown
      startDate={startDate}
      value={value}
      wrapperClassName={wrapperClassName}
      {...rest}
    />
  )
}
